import { createTag as _createTag } from '@griply/services';
import { collection, doc, serverTimestamp, setDoc } from 'firebase/firestore';
import { NewTag } from 'shared/types/tag';

import { getAuthentication, getDatabase } from './helpers';

export const createTag = async (tag: NewTag) => {
  const user = (await getAuthentication()).currentUser;

  if (!user) {
    throw Error('unauthenticated');
  }

  const db = getDatabase();

  return _createTag({
    tag,
    userId: user.uid,
    collection,
    doc,
    setDoc,
    db,
    serverTimestamp,
  });
};
